import { z } from "zod";
import { toFirestoreSchema } from "../utils/toFirestoreSchema";

export const AccountDeletionRequestStatusSchema = z.enum(["pending"]);

export const AccountDeletionRequestSchema = z.object({
  uid: z.string().min(1),
  status: AccountDeletionRequestStatusSchema,
  requestedAt: z.date(),
  displayName: z.string().nullable(),
  phoneNumber: z.string().nullable(),
});

export const AccountDeletionRequestRecordSchema = toFirestoreSchema(AccountDeletionRequestSchema);

export type AccountDeletionRequestStatus = z.infer<typeof AccountDeletionRequestStatusSchema>;
export type AccountDeletionRequest = z.infer<typeof AccountDeletionRequestSchema>;
export type AccountDeletionRequestRecord = z.infer<typeof AccountDeletionRequestRecordSchema>;
